const data = {
  "chat": {
    "buttonLabel": "Ga terug naar de live chat",
    "inputLabel": "Stuur een bericht",
    "inputPlaceholder": "Typ hier je bericht...",
    "inputIcon": "Stuur",
    "you": "Jij",
    "disclaimer": "Onze digitale assistent helpt je, maar kan zich net als een mens soms vergissen.",
    "closeChat": "Chat sluiten"
  },
  "chatbots": {
    "adviceAgent": {
      "headerTitle": "Digitale specialist",
      "errorMessage": "Oeps de specialist is even offline. Probeer het later nog eens.",
      "disclaimer": "Onze digitale specialist helpt je, maar kan zich net als een mens soms vergissen."
    }
  }
};

export default data;